import { connectListView, ListView } from "../../../UI/view/list-view";
import { jdeStuckRecordsDS, liquidBillingManualDS } from "./liquid-billing-datasource";
import { CreateTransfer, CreateTransferDataSource } from "./liquid-create-transfer";
import { liquidBillingListColumns, liquidBillingListToolbar, liquidListFilters } from "./liquid-invoice-list";

export const liquidBillingJDEStuckList = {
  name: 'liquidBillingJDEStuckList',
  filters: liquidListFilters,
  columns: liquidBillingListColumns.filter(x => x.accessor != 'checked'),
  additionalModals: [
    {
      form: CreateTransfer,
      repository: CreateTransferDataSource,
      name: 'createTransfer',
      title: 'Create Transfer',
    }
  ],
  toolbar: liquidBillingListToolbar('liquidBillingManualList'),
} as ListView;

export const [LiquidBillingJDEStuckList, LiquidBillingInvoiceJDEStuckDataSource] = connectListView(liquidBillingJDEStuckList, jdeStuckRecordsDS);